(() => {
  'use strict';
  if (window.__ossJerseyRound8Installed) return;
  window.__ossJerseyRound8Installed = true;
  const qs = (selector, root = document) => root.querySelector(selector);
  const qsa = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  const clean = (value) => String(value == null ? '' : value).trim();
  const parseJson = (node) => { if (!node) return {}; try { return JSON.parse(node.textContent) || {}; } catch (_) { return {}; } };
  const config = parseJson(qs('[data-oss-product-config]'));
  const product = parseJson(qs('[data-product-json]'));
  const tags = Array.isArray(config.tags) ? config.tags.map((tag) => clean(tag).toLowerCase()) : [];
  const type = clean(config.type || product.type).toLowerCase();
  const isJersey = type.includes('jersey') || tags.some((tag) => tag.includes('jersey'));
  if (!isJersey) return;
  const FILE_BASE = 'https://cdn.shopify.com/s/files/1/0473/9609/4117/files/';
  const approvedLogoCandidates = {
    'champions-league': `${FILE_BASE}oss-patch-logo-champions-league.png`,
    'europa-league': `${FILE_BASE}oss-patch-logo-europa-league.png`,
    'conference-league': `${FILE_BASE}oss-patch-logo-conference-league.png`,
    'bundesliga': `${FILE_BASE}oss-patch-logo-bundesliga.png`,
    'laliga': `${FILE_BASE}oss-patch-logo-laliga.png`,
    'serie-a': `${FILE_BASE}oss-patch-logo-serie-a.png`,
    'premier-league': `${FILE_BASE}oss-patch-logo-premier-league.png`,
    'ligue-1': `${FILE_BASE}oss-patch-logo-ligue-1.png`,
    'primeira-liga': `${FILE_BASE}oss-patch-logo-primeira-liga.png`,
    'mls': `${FILE_BASE}oss-patch-logo-mls.png`,
    'eredivisie': `${FILE_BASE}oss-patch-logo-eredivisie.png`,
    'super-lig': `${FILE_BASE}oss-patch-logo-super-lig.png`
  };
  const brandMeta = {
    'champions-league': { label: 'Champions League' }, 'europa-league': { label: 'Europa League' }, 'conference-league': { label: 'Conference League' },
    'bundesliga': { label: 'Bundesliga' }, 'laliga': { label: 'LaLiga' }, 'serie-a': { label: 'Serie A' }, 'premier-league': { label: 'Premier League' },
    'ligue-1': { label: 'Ligue 1' }, 'primeira-liga': { label: 'Primeira Liga' }, 'mls': { label: 'MLS' }, 'eredivisie': { label: 'Eredivisie' }, 'super-lig': { label: 'Süper Lig' }
  };
  const slugForName = (name) => {
    const value = clean(name).toLowerCase();
    if (value.includes('conference league')) return 'conference-league';
    if (value.includes('champions league')) return 'champions-league';
    if (value.includes('europa league')) return 'europa-league';
    if (value.includes('bundesliga')) return 'bundesliga';
    if (value.includes('laliga') || value.includes('la liga')) return 'laliga';
    if (value.includes('serie a')) return 'serie-a';
    if (value.includes('premier league')) return 'premier-league';
    if (value.includes('ligue 1')) return 'ligue-1';
    if (value.includes('primeira liga')) return 'primeira-liga';
    if (value.includes('mls')) return 'mls';
    if (value.includes('eredivisie')) return 'eredivisie';
    if (value.includes('süper lig') || value.includes('super lig')) return 'super-lig';
    return 'generic';
  };
  const syncSelectedState = (row) => {
    const input = qs('.oss-switch input[type="checkbox"]', row) || qs('input[type="checkbox"]', row);
    row.classList.toggle('is-selected', Boolean(input && input.checked));
  };
  const attachApprovedLogo = (row, slug) => {
    if (!approvedLogoCandidates[slug] || row.dataset.ossBrandLogoChecked === slug) return;
    row.dataset.ossBrandLogoChecked = slug;
    const icon = qs('.oss-patch-icon', row);
    if (!icon) return;
    qsa('.oss-patch-brand-logo', icon).forEach((node) => node.remove());
    icon.classList.remove('has-brand-logo');
    const probe = new Image();
    probe.decoding = 'async';
    probe.onload = () => {
      if (!probe.naturalWidth || !probe.naturalHeight || !icon.isConnected) return;
      const img = document.createElement('img');
      img.className = 'oss-patch-brand-logo';
      img.src = approvedLogoCandidates[slug];
      img.alt = '';
      img.setAttribute('aria-hidden', 'true');
      img.decoding = 'async';
      icon.appendChild(img);
      icon.classList.add('has-brand-logo');
    };
    probe.onerror = () => icon.classList.remove('has-brand-logo');
    probe.src = approvedLogoCandidates[slug];
  };
  const themePatchRows = () => {
    qsa('.oss-patch-panel .oss-patch-row').forEach((row) => {
      const nameNode = qs('.oss-patch-copy strong', row);
      const slug = slugForName(nameNode && nameNode.textContent);
      row.dataset.ossPatchTheme = slug;
      row.dataset.ossPatchBrand = brandMeta[slug] ? brandMeta[slug].label : 'Patch';
      syncSelectedState(row);
      if (slug !== 'generic') attachApprovedLogo(row, slug);
    });
  };
  let timer = null;
  const schedule = () => { window.clearTimeout(timer); timer = window.setTimeout(themePatchRows, 25); };
  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!input || !input.matches || !input.matches('.oss-patch-panel input[type="checkbox"]')) return;
    requestAnimationFrame(themePatchRows);
    window.setTimeout(themePatchRows, 40);
  }, true);
  const init = () => {
    document.body.classList.add('oss-round8-ready');
    themePatchRows();
    const root = qs('.product-detail') || document.body;
    new MutationObserver(schedule).observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'checked'] });
    window.setTimeout(themePatchRows, 120);
    window.setTimeout(themePatchRows, 500);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();
